export type ReceivedProps = Record<string, any>;

const useViewAdmin = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useViewAdmin>;

export default useViewAdmin;
